// Ouvrir via [data-sheet="#id"], fermer via [data-sheet-close]
document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-sheet]');
    const closeBtn = e.target.closest('[data-sheet-close]');
    if (openBtn) {
        const sel = openBtn.getAttribute('data-sheet');
        const dlg = document.querySelector(sel);
        if (!dlg) return;
        dlg.showModal?.() ?? dlg.setAttribute('open','');
        document.body.classList.add('no-scroll');
    }
    if (closeBtn) {
        const dlg = closeBtn.closest('dialog.bottom-sheet');
        dlg?.close();
        document.body.classList.remove('no-scroll');
    }
});
// Fermer au clic sur l’arrière-plan
document.addEventListener('click', (e) => {
    const dlg = e.target.closest('dialog.bottom-sheet');
    if (dlg && e.target === dlg) { dlg.close(); document.body.classList.remove('no-scroll'); }
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { document.querySelectorAll('dialog.bottom-sheet[open]').forEach(d => d.close()); document.body.classList.remove('no-scroll'); }
});
